import { createContext } from 'react';
import { CreateBudgetInput } from '@/graphql/generated';

export type AddBudgetFormModalContextProps = {
  closeModal: () => void
  openModal: (budgetData?: CreateBudgetInput) => void
  budgetData: CreateBudgetInput | null
  isOpen: boolean
}

export const AddBudgetFormModalContext = createContext<AddBudgetFormModalContextProps | null>(null)